import React from 'react';
import { FormsyTime } from 'formsy-material-ui/lib';
import TimePicker from './TimePickerWrapper';

const styles = {
  timePickerIcon: { position: 'relative', width: '0!important' },
  timePicker: { display: 'flex', flexDirection: 'row', width: 'auto' },
  clearIcon: {
    // fontSize: '2.2rem',
    cursor: 'pointer',
    position: 'absolute',
    left: '-37px',
    top: '17px',
  },
};

class ClearableFormsyTime extends FormsyTime {
  getRequiredError = () => {
    const { isRequired, isPristine, isValid, isFormSubmitted } = this;

    return isRequired() && !isPristine() && !isValid() && isFormSubmitted() ? this.props.requiredError : null;
  };

  handleTimeClear = () => {
    this.setValue(undefined);
    if (this.props.onChange) {
      this.props.onChange(undefined);
    }
  };
  render() {
    const {
      defaultTime,
      validations,
      validationError,
      validationErrors,
      className,
      disabled,
      requiredError,
      disableClear = false,
      ...rest
    } = this.props;
    const value = this.getValue();
    const isDisabled = this.isFormDisabled() || disabled;
    const errorText = this.getErrorMessage() || this.getRequiredError();
    return (
      <div className={className} style={styles.timePicker}>
        <TimePicker
          className="time-picker"
          disabled={isDisabled}
          {...rest}
          errorText={errorText}
          onChange={this.handleChange}
          ref={this.setMuiComponentAndMaybeFocus}
          value={value}
        />
        {!isDisabled && !disableClear && value && (
          <div className="timepicker-icon" style={styles.timePickerIcon}>
            <i
              tabIndex={0}
              role="button"
              className="allocateIcons"
              style={styles.clearIcon}
              onClick={this.handleTimeClear}
            >
              &#xE14C;
            </i>
          </div>
        )}
      </div>
    );
  }
}

export default ClearableFormsyTime;
